export function apiIdValidator({
  value,
  validationEndpoint,
  errorMessage,
  onSuccess = () => {}
}) {
  if (!value || value.length === 0) {
    return true
  }

  return validationEndpoint(value)
    .then(response => {
      onSuccess(response)
      return true
    })
    .catch(() => errorMessage)
}
